<template>
  <div class="onboarding-dashboard-name">
    <h1 class="onboarding-dashboard-name__message">
      {{ $t('components.Onboarding.label.title.chooseDashboardNameMessage') }}
    </h1>
    <p class="onboarding-dashboard-name__info-message">
      {{ $t('components.Onboarding.label.title.chooseDashboardNameLaterMessage') }}
    </p>
    <v-text-field
      v-model="onboardingData.dashboardName"
      class="onboarding-dashboard-name__input"
      :label="`${this.$t('components.Onboarding.label.title.writeHereMessage')}`"
      outlined
      dense
      @blur="hasDashboardName"
    />
  </div>
</template>

<script>
export default {
  name: 'OnboardingDashboardName',
  props: {
    onboardingData: {
      type: Object,
      required: true,
    },
  },
  methods: {
    hasDashboardName() {
      this.onboardingData.dashboardName = Boolean(this.onboardingData.dashboardName.trim().length) ? this.onboardingData.dashboardName : '';
    },
  },
};
</script>

<style lang="scss" scoped>
  .onboarding-dashboard-name {
    margin-top: 48px;

    &__message {
      color: var(--ds-color-text-1);
      font-weight: var(--ds-font-weight-semibold);
      font-size: var(--ds-font-size-xl);
      line-height: var(--ds-font-line-height-normal);
    }

    &__info-message {
      color: var(---ds-color-text-2);
      font-weight: var(--ds-font-weight-regular);
      font-size: var(--ds-font-size-baseline);
      line-height: var(--ds-font-line-height-normal);
      margin-bottom: var(--ds-spacing-stack-sm);
    }

    &__input {
      width: 388px;
    }
  }
</style>
